var exports = {
  "M": "x93eb46d8--fd141f--menu",
  "q": "x93eb46d8--fd141f--menu-item",
};

module.exports = exports;
